import { signIn } from "@aws-amplify/auth";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthentication } from "../../hooks/useAuthentication";
import "./index.css";
import { LoadingInline } from "../LoadingInline";

const AuthPage = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const navigate = useNavigate();
  const { userId } = useAuthentication();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (userId) {
      navigate(`/chatbot`);
    }
  }, [userId, navigate]);

  const handleChange = useCallback(
    async (e) => {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    },
    [formData]
  );

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      setLoading(true);
      setError("");

      try {
        await signIn({
          username: formData.email,
          password: formData.password,
        });
        setLoading(false);
        navigate("/chatbot");
      } catch (err) {
        console.error(err);
        setLoading(false);
        setError("Email ou senha inválidos. Tente novamente.");
      }
    },
    [formData.email, formData.password, navigate]
  );

  return (
    <div className="chatGPT-app auth-container">
      <div className="auth-card">
        <h1 className="auth-title" style={{ marginBottom: "1rem" }}>
          Login
        </h1>
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">E-mail:</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Digite seu email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Senha:</label>
            <input
              type="password"
              id="password"
              name="password"
              placeholder="Digite sua senha"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>
          {error && <p className="error-message">{error}</p>}

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? <LoadingInline /> : "Enviar"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AuthPage;
